module.exports = __webpack_public_path__ + "static/img/banner.4b0b203f.png";